import { Injectable } from '@angular/core';
import { quickWebLogger } from '@quickweb/logger';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { EnvironmentService } from '@app/core/environment/environment.service'; // en4
import { DatadogSettings } from '@app/core/environment/datadog.model'; // en4
import { Ianalytics, IdatadogMessage, IdatadogMessageFormatted } from '@app/shared/model/datadog-message';

@Injectable({
  providedIn: 'root'
})
export class DatadogService {
  private envDatadog:DatadogSettings;

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService, // en4
  ) {}

  public isInternalNetwork(url: string): Observable<boolean> {
    return this.http.get(url+ '/hello', { responseType: "json" }).pipe(
      map(() => true), // Return true if status code is 200
      catchError((error: HttpErrorResponse) => {
        if ( error.status === 200 ) {
          return of(true); // Return true if status code is 200
        }
        return of(false); // Return false for other errors
      })
    );
  }

  public configureDataDog() {

    // get env do en4 --- en4
    this.environmentService
      .loadEnvironment()
      .subscribe(res => {
        this.envDatadog = res.datadogSettings //set env
        // --- en4

        // --- datadog
        this.isInternalNetwork(this.envDatadog.ddproxy)
        .subscribe(internal => {
          console.log('isInternalNetwork',internal);
          this.initializeDatadog(internal);
        });
        // --- datadog

      // --- en4
      })
      // --- en4

  }

  private initializeDatadog(internal: boolean) {

    //config acesso interno com proxy
    let config = {
      name: this.envDatadog.name,
      version: this.envDatadog.version,
      env: this.envDatadog.environment,
      sigla: this.envDatadog.sigla,
      datadog: {
        logs: {
          clientToken: this.envDatadog.proxyToken,
          maskSensitiveData: true
        },
        rum: {
          applicationId: this.envDatadog.applicationId,
          clientToken: this.envDatadog.proxyToken,
          sessionSampleRate: this.envDatadog.sessionSampleRate,
          trackViewsManually: true,
          maskSensitiveData: true
        }
      },
      externalApplication: false,
    }

    //ajuste config acesso externo sem proxy em prod
    if (!internal){
      config.datadog.logs.clientToken = this.envDatadog.clientTokenExt;
      config.datadog.rum.clientToken = this.envDatadog.clientTokenExt;
      config.externalApplication = true;
    }

    //config datadog
    quickWebLogger.init(config);
    // console.log('dd config',config);
  }



  /**
  * Método que envia o erro para o datadog.
  * @param {string} message - mensagem que será enviada para ferramenta.
  */
  public sendErrorLogs(message: string, context = {}) {
    quickWebLogger.logger.error(message, context);
  }

  /**
   * Método que envia o log para o datadog.
   * @param {string} message - mensagem que será enviada para ferramenta.
   */
  public logInfo(message: string, context: Record<string, unknown> = {}) {
    quickWebLogger.logger.info(message, context);
  }

  /**
  * Método que envia o view para o datadog.
  */
  public sendStartView(pagina: string, contexto?:Record<string, unknown>) {
    const _context = contexto || {};
    quickWebLogger.rum.startView({ pageName: pagina , context: contexto});
  }
  /**
  * Método que envia o user para o datadog.
  */
  public sendSetUser(_id: string, _name?:string) {
    quickWebLogger.rum.setUser({ id: _id , name: _name});
  }

  /**
  * Método utilizado pelo MFE para enviar logs de erro para o datadog.
  */
  public sendErrorLogsChildren(payload: IdatadogMessage): void {
    const analytics = payload.analytics;

    if (!this.validatePayload(analytics, 'dd')) return;

    const {message, context} = this.formatMessage(analytics);
    this.sendErrorLogs(message, context);
  }

  private validatePayload(payload: Ianalytics, key: string): boolean {
    return payload && typeof payload === 'object' && key in payload;
  }

  private formatMessage(payload: Ianalytics): IdatadogMessageFormatted {
    const { applicationUrl, statusCode, name, erro, api, ambiente } = payload.dd,
    message = `status: ${statusCode} nome-mfe: ${name} url: ${applicationUrl}`,
    context = { erro: `${erro}, api: ${api}, ambiente: ${ambiente}`, name };

    return { message, context };
  }
}
